import { gql } from 'graphql-tag';

export const ASSIGN_DEFAULT_EMPLOYEE_ACCOUNT_TO_MEMBER = gql`
  mutation Id86f2ca5b769000335d32c582d4d0c506($companyId: ID!, $memberId: ID!) {
    __typename
  }
`;

export const SET_ACCOUNTING_INTEGRATION = gql`
  mutation Idafa9703fd350185c1edcd556b8ddee32(
    $companyId: ID!
    $accountingSoftware: AccountingSoftware!
  ) {
    __typename
  }
`;

export const SWITCH_ACCOUNTING_INTEGRATION = gql`
  mutation Id50bd05b14ce8f1df02b78a688a897bc2(
    $companyId: ID!
    $accountingSoftware: AccountingSoftware!
  ) {
    __typename
  }
`;
